import { Box } from "chorda-bulma";
export default () => {
    return Box({
        text: 'Hello in Box',
        css: 'is-primary'
    });
};
